export default {
  listItem(params) {
    return Request.get('api/school/client/all', params);
  },
  listTop(params) {
    return Request.get('api/school/client/top', params);
  },
  show(id) {
    return Request.get(`api/school/${id}`);
  },
};
